import { AttestationFormStatus } from '../../../graphql';

export const AttestationFormStatusDisplayName: { [key in AttestationFormStatus]: string } = {
  [AttestationFormStatus.Blanket]: 'Blanket',
  [AttestationFormStatus.Expired]: 'Expired',
  [AttestationFormStatus.NotOnFile]: 'Not on file',
  [AttestationFormStatus.Partial]: 'Partial',
};

export const isAttestationStatusValid = (status: AttestationFormStatus) => {
  return status === AttestationFormStatus.Blanket || status === AttestationFormStatus.Partial;
};

export const getAttestationStatusColor = (status: AttestationFormStatus) => {
  if (isAttestationStatusValid(status)) {
    return 'success';
  }
  return 'error';
};
